export const PACKAGE_NAME = "PlayUI Origin Adapter";
export const PLAY_FOR_FUN_SHOW_DURATION = 2000;
export const PLAY_FOR_FUN_HIDE_DURATION = 8000;
export const DEFAULT_GAME_PRODUCER = "NETENT";
